document.addEventListener('DOMContentLoaded', function () {
  var animatedItems = Array.prototype.slice.call(document.querySelectorAll('[data-aevum-animate]'));

  if ('IntersectionObserver' in window && animatedItems.length) {
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            if (entry.target.dataset.aevumProgress) {
              var progressValue = entry.target.dataset.aevumProgress;
              var progressFill = entry.target.querySelector('.aevum-progress-bar span');
              if (progressFill) {
                progressFill.style.width = progressValue;
              }
            }
            observer.unobserve(entry.target);
          }
        });
      },
      {
        rootMargin: '0px 0px -120px 0px',
        threshold: 0.15,
      }
    );

    animatedItems.forEach(function (item) {
      item.classList.add('aevum-animate');
      observer.observe(item);
    });
  } else {
    animatedItems.forEach(function (item) {
      item.classList.add('is-visible');
    });
  }

  var lazyVideoWrappers = Array.prototype.slice.call(document.querySelectorAll('[data-aevum-video-preload]'));
  lazyVideoWrappers.forEach(function (wrapper) {
    var video = wrapper.querySelector('video');
    if (!video) {
      return;
    }

    var preloadObserver = new IntersectionObserver(
      function (entries, preloadObserver) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            video.preload = 'auto';
            preloadObserver.unobserve(entry.target);
          }
        });
      },
      {
        rootMargin: '0px 0px 300px 0px',
        threshold: 0.01,
      }
    );

    preloadObserver.observe(wrapper);
  });

  /* Parallax-like overlay darkening on scroll for precommande hero */
  var overlays = Array.prototype.slice.call(document.querySelectorAll('.precommande-01-hero .aevum-video-overlay'));
  if (overlays.length) {
    var ticking = false;
    var baseAlpha = 0.65; // matches CSS default overlay alpha

    function onScroll() {
      if (!ticking) {
        window.requestAnimationFrame(function () {
          var scrollY = window.scrollY || window.pageYOffset;
          var viewport = window.innerHeight || document.documentElement.clientHeight;
          var progress = Math.min(1, Math.max(0, scrollY / viewport));
          var extra = 0.4 * progress; // up to +0.4 opacity
          overlays.forEach(function (overlay) {
            var alpha = Math.min(1, baseAlpha + extra);
            overlay.style.background = 'linear-gradient(180deg, rgba(17,17,17,' + alpha + ') 0%, rgba(17,17,17,' + alpha + ') 20%, transparent 50%)';
          });
          ticking = false;
        });
        ticking = true;
      }
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    // initialize once
    onScroll();
  }

    /* Hide hero scroll indicator after user scrolls down */
    var heroScrollEl = document.querySelector('.aevum-hero-scroll');
    if (heroScrollEl) {
      function checkHeroScroll() {
        var sc = window.scrollY || window.pageYOffset;
        if (sc > 180) {
          heroScrollEl.classList.add('is-hidden');
        } else {
          heroScrollEl.classList.remove('is-hidden');
        }
      }

      window.addEventListener('scroll', checkHeroScroll, { passive: true });
      // initial state
      checkHeroScroll();
    }
});
